// extracted by mini-css-extract-plugin
module.exports = {"link":"TradeDescription_link__qrWrn"};